import { boldCellSx } from '../../../components/ui/tableTemplate/cellRenderers';
import type { ContractListItem } from '../contractTypes';

/**
 * The selected row — the one whose details are shown below the contract-history
 * list — is emphasised in bold, so it stands out from the other rows. This
 * tracks the selection, not the current-contract status: the current contract
 * is only bold while it is the one being displayed (the default view).
 *
 * Returns the bold `sx` for the selected row, `undefined` otherwise.
 */
export const boldIfSelected = (row: ContractListItem, selectedContractId: string | null) =>
  row.hc_uuid_key === selectedContractId ? boldCellSx : undefined;
